/**
 *
 */
export default [
    {
        text: '#',
        value: 'id',
        sortable: true,
        width: '1%',
    },
    {
        text: 'facturas',
        value: 'invoice_numbers',
        component: {
            type: 'chip-list',
            props: {
                small: true,
            },
        },
        width: '5%',
    },
    {
        text: 'rut',
        value: 'pch_provider_rut',
        format: 'rut',
    },
    {
        text: 'proveedor',
        value: 'pch_provider_business_name',
        component: {
            custom: 'pch_provider_id',
            type: 'link',
            props: {
                mapper: value => ({
                    name: 'provider-update',
                    params: {
                        id: value,
                    },
                }),
                tooltip: 'Detalle proveedor',
            },
        },
    },
    {
        text: 'sucursal',
        value: 'pch_provider_branch_offices_address',
    },
    {
        text: 'neto',
        value: 'net_subtotal',
        align: 'right',
        format: 'currency',
    },
    {
        text: 'iva',
        value: 'iva',
        align: 'right',
        format: 'currency',
    },
    {
        text: 'total',
        value: 'total',
        align: 'right',
        format: 'currency',
        classes: 'accent lighten-3 font-weight-medium',
    },
    {
        text: 'recepción',
        value: 'receiving_date',
        align: 'right',
        format: 'datetime',
    },
    {
        text: 'creación',
        value: 'created_at',
        align: 'right',
        format: 'datetime',
    },
]
